import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertiesComponent } from './properties.component';
import { AppRoutingModule } from '../app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { MaterialModule } from '../material.module';
import { PropertyPipe } from '../shared/filters/property.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [PropertiesComponent, PropertyPipe],
  imports: [
    CommonModule,
    AppRoutingModule,
    BrowserModule,
    MaterialModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [
    PropertiesComponent
  ]
})
export class PropertiesModule { }
